import H from 'history'
import { SectionMetaInfoDTO } from 'publication-types'

export function locationToFullPath(location: H.Location) {
    return `${location.pathname}${location.hash ? `#${location.hash}` : ''}${
        location.search ? `?${location.search}` : ''
    }`
}

export function getBaseUrl(publicUrl: string, sectionInfo?: SectionMetaInfoDTO) {
    if (sectionInfo && sectionInfo.Hostname) {
        return `https://${sectionInfo.Hostname}`
    }
    return publicUrl
}
